import React from 'react';
import { useFormikContext, Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';

const SuperProfileRequiredLanguageProficiencyProficiencyDropdown = ({ index }) => {
  const {
    values: { requiredLanguageProficiencies },
    errors,
    setFieldValue,
  } = useFormikContext();

  const hasError =
    errors.requiredLanguageProficiencies && errors.requiredLanguageProficiencies[index]
      ? !!errors.requiredLanguageProficiencies[index].proficiency
      : false;

  const options = [
    {
      label: 'Beginner',
      value: 'BEGINNER',
    },
    {
      label: 'Intermediate',
      value: 'INTERMEDIATE',
    },
    {
      label: 'Advanced',
      value: 'ADVANCED',
    },
  ];

  return (
    <div className="margin-bottom-0-5">
      <div className="flex-space-between">
        <FormattedMessage
          id="account.super-profiles.new.required-language-proficiencies.proficiency"
          defaultMessage="Required language proficiency"
        >
          {(text) => (
            <label className="field-label" htmlFor={`requiredLanguageProficiencies.${index}.proficiency`}>
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              name={`requiredLanguageProficiencies.${index}.proficiency`}
              component={DropdownComponent}
              filter
              className="right"
              value={requiredLanguageProficiencies[index].proficiency}
              options={options}
              hasError={hasError}
              onChange={(option) => setFieldValue(`requiredLanguageProficiencies.${index}.proficiency`, option.value)}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileRequiredLanguageProficiencyProficiencyDropdown;
